import { observer } from 'mobx-react';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import i18n from '../../i18n';
import { RedirectContext } from '../../core/enums/RedirectContext';
import { useStores } from '../../hooks';
import { getAuth0LoginWithRedirectOptions, getPostLoginReturnTarget, RouterPaths } from '../../router';

export const Login = observer(function LoginComponent() {
    const {
        ui: { router, app },
    } = useStores();

    const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

    useEffect(() => {
        if (isLoading) {
            return;
        }

        const isAuthenticatedHandler = async () => {
            try {
                const token = await app.refreshAuthorization();

                if (!token) {
                    router.push(RouterPaths.BasePages.Signup);
                    return;
                }

                const returnPath = getPostLoginReturnTarget();
                if (returnPath) {
                    router.replace(returnPath);
                    return;
                }

                await router.redirectToTarget(RedirectContext.ENTRY);
            } catch (error) {
                console.error('auto0 token validation failed ', error);

                await app.logout();
                return;
            }
        };

        if (!isAuthenticated) {
            const { redirectUri, appState } = getAuth0LoginWithRedirectOptions();
            void loginWithRedirect({
                appState,
                authorizationParams: {
                    ui_locales: i18n.language,
                    redirect_uri: redirectUri,
                },
            });
        } else {
            void isAuthenticatedHandler();
        }
    }, [isLoading, isAuthenticated]);

    return <div>{i18n.t('common:loading', 'Loading...')}</div>;
});
